export const sanitizeBackupFarmName = (farmName) => {
  const withoutControlCharacters = Array.from(String(farmName || ''))
    .filter((character) => character.charCodeAt(0) >= 32)
    .join('');
  const sanitized = withoutControlCharacters
    .trim()
    .replace(/[<>:"/\\|?*]/g, '_')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^[._-]+|[._-]+$/g, '')
    .slice(0, 80);

  return sanitized || 'Farm';
};

export const createBackupFilename = (farmName, backupType, dateStamp) => (
  `${sanitizeBackupFarmName(farmName)}-${backupType}-Backup-${dateStamp}.micgro`
);

export const createInvoiceDownloadFilename = (farmName, dateStamp) => (
  `${sanitizeBackupFarmName(farmName)}-Invoices-${dateStamp}.zip`
);
